document.addEventListener("DOMContentLoaded", function() {
    // Select the PMT sticky header
    var header = document.querySelector(".header-sticky-rv");
    var accouncement_bar = document.querySelector(".announcement-bar");
    var className = "scroll-active-rv";

    if (!header) return; // exit if header not found

    // Function to toggle class
    function toggleScrollClass() {
        if (window.scrollY > 0) {
            header.classList.add(className);
            if (accouncement_bar) accouncement_bar.classList.add(className);
        } else {
            header.classList.remove(className);
            if (accouncement_bar) accouncement_bar.classList.remove(className);
        }
    }

    // Listen to scroll
    window.addEventListener("scroll", toggleScrollClass);

    // Trigger once on page load in case already scrolled
    toggleScrollClass();
});
